<script>
export default {
    name: 'BaseDatatable',
    props: {
        drfprovider: {
            type: Function,
            required: false,
            default: () => null
            },
        provider: {
            type: Function,
            required: false,
            default: () => null
            },
        tableheaders: {
            type: [Array, Object],
            required: true
            },
        perpage: {
            type: Number,
            required: false,
            default: 10
            },
        pageoptions: {
            type: Array,
            required: false,
            default() {
                    let pages = []
                    let perpage = this.perpage
                    for (let index = 1; index < 5; index++) {
                        pages.push(index * perpage)
                    }
                    pages.push(perpage * 10)
                    return pages
                }
            },
        sortby: {
            type: String,
            required: false,
            default: ''
            },
        sortdesc: {
            type: NaN,
            required: false,
            default: null
        },
        emptyText: {
            type: String,
            default: 'Sin registros para mostrar'
        },
        emptyFilteredText: {
            type: String,
            default: 'No se encontraron registros'
        },
        responsiveTable: {
            type: Boolean,
            default: true,
            required: false,
        },
        filtermaxrows: {
            type: Number,
            default: null,
            required: false,
        },
        showFilter:{
            type: Boolean,
            default: true,
            required: false,
        }
    },
    data() {
        return {
            isBusy: false,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            lastFilter: '',
        }
    },
    methods: {
        onFiltered(filteredItems) {
            if (this.filter !== this.lastFilter){
                // Trying to resolve filter search issues when
                // changing pages with an active filter
                this.currentPage = 1
                this.lastFilter = this.filter
            }
        },
        baseProvider(ctx){
            let promise = this.drfprovider(ctx)
            if (promise){
                return promise.then((data) =>{
                    this.totalRows = data.count
                    return data.results
                })
            }else{
                return this.provider(ctx)
            }
        },
        refresh(){
            this.$refs.table.refresh()
        }
    }
}
</script>
<template>
    <b-container fluid class="p-0">
        <b-row align-h="between">
            <b-col v-if="perpage < 999" md="6" lg="6" sm="8" xl="6" xxl="6" class="my-1">
                <label for="perPageSelect" class="mr-2 font-weight-light">{{ $t('datatable.recordsperpage') }}</label>
                <b-form-select
                    id="perPageSelect"
                    v-model="perpage"
                    size="sm"
                    class="col-xl-5 col-xxl-4 col-lg-5 col-md-7 col-sm-6 col-xs-6"
                    style="width: 70px"
                    :options="pageoptions"
                ></b-form-select>
            </b-col>
            <b-col md="6" lg="6" sm="4" xl="6" xxl="6" class="my-1" v-if="filtermaxrows ? totalRows <= filtermaxrows : true && showFilter">
                <div class="float-right">
                    <b-input-group size="sm" :prepend="$t('datatable.filter')">
                        <b-form-input
                            id="filterInput"
                            v-model="filter"
                            autocomplete="search-datatable"
                            debounce="600"
                            type="search"
                            :placeholder="$t('datatable.typetosearch')">
                        </b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''" class="d-none d-lg-block">{{ $t('datatable.clear') }}</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="p-0">
                <b-table
                    ref="table"
                    class="m-0"
                    striped hover small
                    :items="baseProvider"
                    :fields="tableheaders"
                    :per-page="perpage"
                    :current-page="currentPage"
                    :busy="isBusy"
                    :filter="filter"
                    :sort-by.sync="sortby"
                    :sort-desc.sync="sortdesc"
                    :responsive="responsiveTable"
                    show-empty
                    :empty-text="emptyText"
                    :empty-filtered-text="emptyFilteredText"
                    @filtered="onFiltered"
                >
                    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
                    <template v-slot:table-busy>
                        <div class="text-center text-corp my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> {{ $t('datatable.loading') }}...</strong>
                        </div>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="5" md="4" class="pt-2 my-1 text-muted">
                {{ $t('datatable.showing') }} <span style="color: #F28C02">{{ !totalRows ? 0 : ((currentPage - 1) * perpage) + 1 }} - {{ !totalRows ? 0 : currentPage * perpage >= totalRows ? totalRows : currentPage * perpage }} {{ $t('datatable.of') }} {{ totalRows }} </span> 
                <!--{{ $t('datatable.totalrows') }}-->
            </b-col>
            <b-col v-if="perpage < 999" offset-md="5" sm="7" md="3" class="my-1">
                <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perpage"
                align="right"
                size="md"
                class="my-0"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>